export const facebook = 'https://www.facebook.com';
export const instagram = 'https://www.instagram.com';
export const medium = 'https://medium.com';
export const spotify = 'https://www.spotify.com';
export const tiktok = 'https://www.tiktok.com';
export const twitter = 'https://twitter.com';
export const youtube = 'https://www.youtube.com';

// our own site
export const tinder = 'https://tinder.com';
export const lite = 'https://lite.tinder.com';

export const help = 'https://www.help.tinder.com';
export const policies = 'https://policies.tinder.com';
export const pressroom = 'https://www.tinderpressroom.com';

// tracker
export const utm = '?utm_source=web';
export const appsflyer = 'https://open.tinder.com';
export const branch = 'https://go.tinder.com';
export const onelink = 'https://tinder.onelink.me';
